import { useState, useCallback } from 'react';

export const useModal = () => {
  const [isOpen, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    openModal,
    closeModal,
    modalProps: { isOpen, onRequestClose: closeModal },
  };
};
